export const WAREHOUSES_SUPPORTING_MAX_HEIGHT = ["EWR1RS", "LAX1RS"];
